import { LAYOUT_TYPES } from '@/config/app';
import { BREAKPOINTS } from '@/config/breakpoints';

const DEVICE_RULES = [
    {
        type: LAYOUT_TYPES.MOBILE,
        classCondition: LAYOUT_TYPES.MOBILE,
    },
    {
        type: LAYOUT_TYPES.TABLET,
        classCondition: LAYOUT_TYPES.DESKTOP,
        mediaQuery: `(max-width: ${BREAKPOINTS.xl - 1}px)`,
    },
    {
        type: LAYOUT_TYPES.DESKTOP,
        classCondition: LAYOUT_TYPES.DESKTOP,
        mediaQuery: `(min-width: ${BREAKPOINTS.xl}px)`,
    },
];

function getDeviceType(rules = DEVICE_RULES) {
    const deviceType = rules.find((rule) => {
        const classCondition = document.documentElement.classList.contains(rule.classCondition);

        if (rule.mediaQuery) {
            return classCondition && window.matchMedia(rule.mediaQuery).matches;
        }

        return classCondition;
    });

    return deviceType ? deviceType.type : null;
}

function detectIOS() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const platform = navigator.platform;

    const isIpad = /iPad/i.test(userAgent) || (navigator.maxTouchPoints > 1 && /MacIntel/.test(platform));
    const isIphone = /iPhone/i.test(userAgent) && !isIpad;
    const isIpod = /iPod/i.test(userAgent);
    const isIOS = isIpad || isIphone || isIpod;

    const isSafari = /Safari/i.test(userAgent) && !/Chrome|CriOS/i.test(userAgent);

    const iosVersion = (() => {
        const match = userAgent.match(/OS (\d+)_/i);
        return match ? parseInt(match[1], 10) : null;
    })();

    return {
        isIOS,
        isIpad,
        isIphone,
        isIpod,
        isSafari,
        iosVersion,
    };
}

function getDeviceDetails() {
    const iosDetails = detectIOS();

    return {
        ...iosDetails,
    };
}

export { getDeviceType, getDeviceDetails };
